import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { PlanProDetails } from './components/PlanProDetails';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaFooter } from './components/CtaFooter';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  const [selectedPlan, setSelectedPlan] = useState(1);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-emerald-200 selection:text-emerald-900" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <StatsBar data-id="element-4" />
        <ModulesSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <PricingSection selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} data-id="element-7" />
        <PlanProDetails selectedPlan={selectedPlan} data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
      </main>

      <CtaFooter data-id="element-10" />

      <PurchasePopup data-id="element-11" />
    </div>;
}